import React, { useEffect, useLayoutEffect } from "react";
import RoutePaths from "./routes/Routes";
import { useDispatch, useSelector } from "react-redux";
import { setCartConfig, setConfig } from "./store/axiosConfigSlice";
import { ErrorBoundary } from "@sentry/react";
import { getBasicDineData, getBasicData } from "./services";
import {
  getDineConfigSession,
  setCartConfigSession,
  getSSIPSession,
  getUserSessionId,
  setSsipSession,
  setSessionUserId,
  setAxiosDefaults,
} from "./utils";

function App() {
  const dispatch = useDispatch();
  const { cartConfig, config } = useSelector((state) => state.axiosConfig);

  useLayoutEffect(() => {
    const isSSIPAvilable = getSSIPSession();
    // const isSSIPAvilable = getSSIPSession();
    // console.log("hjgtghft getSSIPSession isDataAvailable", isSSIPAvilable);
    if (isSSIPAvilable) {
      (async () => {
        const { status, data } = await getBasicData();
        if (status === 200) {
          // console.log("hii i am here ", status, data);
          setAxiosDefaults();
          setSsipSession(data.config.ssip);
          dispatch(setCartConfig(data.config));
          dispatch(setConfig(data.cartConfig));
        }
      })();
    }
  }, []);
  useEffect(() => {
    const body = document.querySelector("#root");

    body.scrollIntoView(
      {
        behavior: "smooth",
      },
      500
    );
  }, []);

  useEffect(() => {
    dispatch({
      type: "BASIC_DINE_DATA",
    });
  }, []);

  return (
    <ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <RoutePaths />
    </ErrorBoundary>
  );
}

export default App;
